import type { FC } from 'react';
import { useTheme } from '@mui/material/styles';
import { color, diagramStyle } from './palette';

/** The engagement path: the six stages of an onboarding engagement, and what the ops console shows at each. */
export const EngagementPath: FC = () => {
  const theme = useTheme();
  const sub = { fill: color.muted, fontSize: 13 } as const;
  const lbl = { fontSize: 14, fontWeight: 600 } as const;
  const stages: Array<{ lines: string[]; console: string }> = [
    { lines: ['scope'], console: 'go-live criteria' },
    { lines: ['sources'], console: 'files received' },
    { lines: ['entity', 'mapping'], console: 'match ladder' },
    { lines: ['first', 'batches'], console: 'Bronze landed' },
    { lines: ['reconciliation', 'queue'], console: 'open exceptions' },
    { lines: ['handoff'], console: 'sign-off' },
  ];

  return (
    <svg viewBox="0 0 940 240" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="The engagement path" style={diagramStyle(theme)}>
      <defs>
        <marker id="academy-arrow-engagement" markerWidth="8" markerHeight="8" refX="7" refY="4" orient="auto">
          <path d="M0,0 L8,4 L0,8 z" fill={color.muted} />
        </marker>
      </defs>
      {stages.map(({ lines, console: shows }, i) => {
        const x = 20 + i * 152;
        const cx = x + 64;
        const last = i === stages.length - 1;
        return (
          <g key={shows}>
            <rect x={x} y="60" width="128" height="60" rx="10" fill={last ? color.ok : 'none'} fillOpacity={last ? 0.15 : 1} stroke={last ? color.ok : color.muted} strokeWidth="2.5" />
            {lines.map((line, l) => (
              <text key={line} x={cx} y={lines.length === 1 ? 95 : 87 + l * 18} textAnchor="middle" style={lbl} fill={color.fg}>
                {line}
              </text>
            ))}
            {!last && <line x1={x + 130} y1="90" x2={x + 150} y2="90" stroke={color.muted} strokeWidth="2" markerEnd="url(#academy-arrow-engagement)" />}
            {/* Where the ops console shows this stage */}
            <line x1={cx} y1="122" x2={cx} y2="174" stroke={color.muted} strokeWidth="1.5" strokeDasharray="2 4" />
            <rect x={cx - 12} y="176" width="24" height="16" rx="2" fill="none" stroke={color.accent} strokeWidth="2" />
            <line x1={cx} y1="192" x2={cx} y2="198" stroke={color.accent} strokeWidth="2" />
            <text x={cx} y="220" textAnchor="middle" style={sub}>
              {shows}
            </text>
          </g>
        );
      })}
      <text x="920" y="40" textAnchor="end" fontSize="13" fill={color.muted}>
        below each: what the ops console shows
      </text>
    </svg>
  );
};
